import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"

export type MenuTriggerProps = {
  /** The trigger element content */
  children?: React.ReactNode
  /** Replace the default button with your own element */
  render?: React.ReactElement
  /** Whether the trigger is disabled */
  disabled?: boolean
  /** Accessible label for icon-only triggers with no visible text */
  "aria-label"?: string
}

const triggerStyles = [
  "inline-flex cursor-pointer items-center gap-1.5 rounded-md",
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
].join(" ")

export function MenuTrigger({ children, render, disabled, "aria-label": ariaLabel }: MenuTriggerProps) {
  return (
    <MenuPrimitive.Trigger
      data-slot="menu-trigger"
      render={render}
      className={triggerStyles}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </MenuPrimitive.Trigger>
  )
}

MenuTrigger.displayName = "Menu.Trigger"
